<template>
  <div class="row">
    <div class="table">
      <tr>
        <td style="border-top: 0px solid !important;">
          <div
            class="
              card card-cob
              shadow-sm
              bg-secondary
              text-center
              position-relative
            "
          >
            <div class="card__selection">
              <input
                :id="`check${orden}`"
                type="checkbox"
                @change="handleCheck"
                v-model="data.check"
              />
              <div
                class="radio selection__custom"
                v-bind:class="[data.check ? 'radio--checked' : '']"
                @click="handleFakeCheck"
              ></div>
            </div>
            <div class="card__title">
              <div class="card__image text-center w-100">
                <img :src="myIcon" alt="logo" class="w-100" />
              </div>
            </div>
          </div>
        </td>
        <td style="border-top: 0px solid !important;">
          <p class="text-dark font-label mt-3">
            <span style="font-size: 12px; display: block;">{{ title }}</span>
            <span style="font-size: 12px; font-weight: bold"
              >Por sólo ${{ cost }}</span
            >
          </p>
        </td>
      </tr>
    </div>
  </div>
</template>

<script>
import icons from "./icons.sample";
import samleIcon from "@/assets/icons/cobs/Coberturas/rc.svg";
export default {
  data() {
    return {
      icons,
      icon: samleIcon,
      test: null,
      myIcon: null,
      shortname: null,
    };
  },
  props: {
    image: String,
    data: Object,
    title: String,
    desc: String,
    name: String,
    radio: Boolean,
    updateSuma: Function,
    deducible: Number,
    suma: Number,
    cost: String,
    modalDescripcionCobertura: Function,
    orden: Number,
  },
  methods: {
    handleCheck(e) {
      const check = e.target;
      const customCheck =
        check.parentElement.querySelector(".selection__custom");

      if (check.checked && this.data.check) {
        customCheck.classList.add("radio--checked");

        this.updateSuma(check.checked, this.name, this.deducible, this.suma);
      } else {
        customCheck.classList.remove("radio--checked");

        this.updateSuma(check.checked, this.name, this.deducible, this.suma);
      }
    },
    handleFakeCheck(e) {
      const fakeCheck = e.target.classList.contains("fa")
        ? e.target.parentElement
        : e.target;
      const input = fakeCheck.parentElement.querySelector("input");

      if (fakeCheck.classList.contains("radio--checked")) {
        fakeCheck.classList.remove("radio--checked");
        input.checked = false;
        this.updateSuma(false, this.name, this.deducible, this.suma);
      } else {
        fakeCheck.classList.add("radio--checked");
        input.checked = true;
        this.updateSuma(true, this.name, this.deducible, this.suma);
      }
    },
    getRoute(src) {
      if (!src) {
        return;
      }

      return src;
    },
  },
  mounted() {
    const iconRoute = this.icons.find((icon) => icon.name == this.name);

    if (iconRoute) {
      this.myIcon = iconRoute.image;
    } else {
      this.myIcon = require("@/assets/icons/cobs/Coberturas/danos_materiales.svg");
    }

    if (iconRoute) {
      this.shortname = iconRoute.shortname;
    } else {
      this.shortname = "Asistencia";
    }
  },
};
</script>

<style lang="scss">
.card__image {
  width: 80px;
  height: 80px;
  img {
    max-height: 100%;
  }
}
.card__cobs {
  width: calc(50% - 5px);
  //   min-width: 150px;
  margin-bottom: 10px;
}
@media only screen and (min-width: 720px) {
  .card__cobs {
    width: calc(30% - 10px);
    min-width: 150px;
    margin: 0 10px 20px 10px;
  }
}
@media only screen and (min-width: 1000px) {
  .card__cobs {
    width: calc(25% - 20px);
    min-width: 150px;
    margin: 0 10px 20px 10px;
  }
}
.card-cob {
  background-color: white !important;
  border-radius: 30px !important;

  .card__selection {
    input {
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .card__icon {
    font-size: 40px;
  }
  .card__title {
    h4 {
      font-size: 18px;
    }
  }
  .card__desc {
    p {
      font-size: 12px;
    }
  }
}
.radio {
  width: 20px;
  height: 20px;
  background-color: #f4f5f7;
  border: 1px solid gray;
  position: absolute;
  right: -5px;
  top: -5px;
  border-radius: 50%;

  .fa {
    display: none;
  }
}
.radio--checked {
  background-color: #00db23 !important;
  border: 1px solid #47bc1e !important;
  .fa {
    display: block !important;
    color: white;
    font-size: 14px;
    padding-top: 2px;
  }
}
</style>